"use client";

export { useUser } from "@/contexts/user-context";
